// Bridges the ids Criteo echoes back (child / colourWay ids) to the parent
// product ids that the "you might also like" tiles are keyed on. This is the
// join that decides whether a returned sponsored product can be matched to a
// rendered tile (and therefore painted). It is extracted so it can be tested in
// isolation against real product-summary shapes, not just aligned mocks.
const buildChildToParentIdMap = (productsWithVariants) => {
  const childToParentIdMap = new Map();

  (productsWithVariants || []).forEach((product) => {
    const parentId = Number(product?.id);
    if (!Number.isFinite(parentId)) {
      return;
    }

    // Parent IDs should resolve to themselves when no translation is needed.
    childToParentIdMap.set(parentId, parentId);

    (product?.variants || []).forEach((variant) => {
      const childId = Number(variant?.id);
      if (Number.isFinite(childId)) {
        childToParentIdMap.set(childId, parentId);
      }

      const colourWayId = Number(variant?.colourWayId);
      if (
        Number.isFinite(colourWayId) &&
        !childToParentIdMap.has(colourWayId)
      ) {
        childToParentIdMap.set(colourWayId, parentId);
      }
    });
  });

  return childToParentIdMap;
};

export default buildChildToParentIdMap;
